import Image from 'next/image';
import { FC } from 'react';
import NGSkeleton from 'src/styles/theme/components/NGSkeleton';
import { StyledCoverImage } from './CoverImage.styles';
import { ICoverImage } from './CoverImage.type';

const CoverImage: FC<ICoverImage> = ({
	isVisible = false,
	src = '',
	alt = '',
	isLoading = false,
	loaderTransparentBackground = false,
	loaderWithBorder = false
}) => {
	return (
		<StyledCoverImage isVisible={isVisible}>
			{!isLoading ? (
				src ? (
					<Image quality={100} src={src} alt={alt} layout='fill' objectFit='cover' draggable={false} priority />
				) : null
			) : (
				<NGSkeleton
					width='100%'
					height='100%'
					transparentBackground={loaderTransparentBackground}
					withBorder={loaderWithBorder}
				/>
			)}
		</StyledCoverImage>
	);
};

export { CoverImage };
